"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var engineIoClient = require("engine.io-client");
var DynaNodeLocalInstanceConnection_1 = require("./DynaNodeLocalInstanceConnection");
var DynaNodeWSConnection_1 = require("./DynaNodeWSConnection");
var consoleStringify_1 = require("../utils/consoleStringify");
function createConnection(config) {
    if (config.dynaNodeAddress.server.secureLevel === "i")
        return createLocalInstanceServerConnection(config);
    else
        return createWSConnection(config);
}
exports.createConnection = createConnection;
function createLocalInstanceServerConnection(config) {
    return __awaiter(this, void 0, void 0, function () {
        var connectionConfig, connection, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    connectionConfig = {
                        serverAddress: config.dynaNodeAddress.serverAddress,
                        onMessage: config.onMessage,
                        onConnectionClose: config.onConnectionClose,
                        onError: config.onError,
                    };
                    connection = new DynaNodeLocalInstanceConnection_1.DynaNodeLocalInstanceConnection(connectionConfig);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, connection.connect()];
                case 2:
                    _a.sent();
                    return [2 /*return*/, connection];
                case 3:
                    error_1 = _a.sent();
                    throw {
                        section: 'DynaNodeLocalInstanceConnection(client)/createConnection',
                        code: 17092308,
                        message: "General error: Cannot create connection to [" + config.dynaNodeAddress.address + "]",
                        data: {
                            recipientDNA: config.dynaNodeAddress,
                        },
                        error: error_1,
                    };
                case 4: return [2 /*return*/];
            }
        });
    });
}
function createWSConnection(config) {
    var resolved = false;
    return new Promise(function (resolve, reject) {
        try {
            var socket_1 = engineIoClient(config.dynaNodeAddress.wsServerAddress, {
                rememberUpgrade: true,
                transports: ['websocket'],
                secure: true,
                rejectUnauthorized: false,
            });
            // todo: binary issue, still not working
            socket_1.binaryType = 'blob';
            socket_1.on('open', function () {
                resolved = true;
                resolve(new DynaNodeWSConnection_1.DynaNodeWSConnection({
                    serverAddress: config.dynaNodeAddress.serverAddress,
                    engineIOSocket: socket_1,
                    onMessage: config.onMessage,
                    onConnectionClose: config.onConnectionClose,
                    onError: config.onError,
                }));
            });
            // dev info: this error is fired at any time asynchronously... probably cannot bound for a specific send probably this should be removed at all
            socket_1.on('error', function (error) {
                var errorReport = {
                    section: 'DynaNodeConnection(client)/createConnection',
                    code: 17092306,
                    message: "General socket error to address: [" + config.dynaNodeAddress.address + "]",
                    data: {
                        recipientDNA: config.dynaNodeAddress,
                    },
                    error: error,
                };
                if (resolved) {
                    console.error("DynaNodeClient [" + (config.prefixAddress || 'no prefixAddress') + "]: createWSConnection: Error occurred after success open to " + config.dynaNodeAddress.address + ", this is an edge case.", consoleStringify_1.consoleStringify(errorReport));
                }
                else {
                    reject(errorReport);
                }
            });
        }
        catch (error) {
            reject({
                section: 'DynaNodeConnection(client)/createConnection',
                code: 17092307,
                message: "General error: Cannot create connection to [" + config.dynaNodeAddress.address + "]",
                data: {
                    recipientDNA: config.dynaNodeAddress,
                },
                error: error,
            });
        }
    });
}
//# sourceMappingURL=createConnection.js.map